<div>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">Configure Batching Options</h4>
  </div>
  <div class="modal-body">
    @if (displayDocumentConfigOutBatchers?.length > 0) {
      @for (documentConfigOutBatcher of displayDocumentConfigOutBatchers; track documentConfigOutBatcher) {
        <div>
          <app-developer-document-configs-batching-type [documentConfigOutBatcher]="documentConfigOutBatcher" [formValidationGroup]="formValidationGroup"></app-developer-document-configs-batching-type>
        </div>
      }
    } @else {
      <br />
      <p class="italic">There is nothing to configure</p>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="save()" [disabled]="displayDocumentConfigOutBatchers?.length < 1 || !isFormValid">Save</button>
    <button type="button" class="btn btn-link" (click)="cancel()">Cancel</button>
  </div>
</div>